import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Creators as menuActions } from '../../store/ducks/menu-ativo';

import RootView from '../rootView';
import ListaDepartamentoWrapper from '../listaDepartamentoWrapper';

class Departamento extends Component {
    componentDidMount() {
        this.props.selectMenu('book-filled');
    }

    render() {
        const { navigation } = this.props;

        return (
            <RootView navigation={navigation}>
                <ListaDepartamentoWrapper navigation={navigation} />
            </RootView>
        );
    }
}

const mapStateToProps = ({ menuAtivo }) => ({
    menuAtivo
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ ...menuActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Departamento);
